export default __webpack_public_path__ + "static/tatatrust-f33adfa6274e2f657e3125cf9b89c3fc.png";